// THE RHYTHM COMBO — pure rules (no timers, no DOM). A one-button game gets a skill layer: clicks that keep coming within
// ComboConfig.gapMs of each other build the combo a step at a time (1 / steps per click, up to 1); let the gap pass and it
// drains to nothing over decayMs (whatever its size). The click value is multiplied by comboMult(value) = 1 + maxBonus × value. The click sound's
// pitch follows the same value, so a streak audibly climbs. Tests: scripts/qa/combo.test.mjs.

export const emptyCombo = () => ({ value: 0, lastAt: null })

// The combo as it stands at `now` (ms): held while the last click is within the window, then fading linearly.
export function comboAt(state, now, cfg) {
  if (!state || state.lastAt == null || state.value <= 0) return 0
  const gap = now - state.lastAt
  if (gap <= cfg.gapMs) return state.value
  return state.value * Math.max(0, 1 - (gap - cfg.gapMs) / cfg.decayMs) // (proportional: any combo drains in decayMs, so the meter always empties at one pace)
}
// True while the window is open (the next click will add to the streak rather than restart it).
export const comboLive = (state, now, cfg) => !!state && state.lastAt != null && now - state.lastAt <= cfg.gapMs && state.value > 0

// The state after a click at `now`.
export function comboAfterClick(state, now, cfg) {
  const cur = comboAt(state, now, cfg)
  return { value: Math.min(1, cur + 1 / cfg.steps), lastAt: now }
}
export const comboMult = (value, cfg) => 1 + cfg.maxBonus * Math.max(0, Math.min(1, value))
// The semitone step the click sound uses (0 … maxSemitones).
export const comboSemitone = (value, cfg) => Math.round(Math.max(0, Math.min(1, value)) * (cfg.maxSemitones ?? 7))
